import { render } from "./UnlinkIcon.vue?vue&type=template&id=e99d105c"
import script from "./UnlinkIcon.vue?vue&type=script&lang=js"
export * from "./UnlinkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__